<template lang="pug">
#staff_care
  .container.custom_container_lg
    .row
      breadcrumb
  section.container.custom_container_md.custom_container_news_sm
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center.text-lg-left
        h2.title.bottom_line {{ financialFriendly.area02_SubTitle }}
    .row.i_mt_8
      .col-12
        p.i_body_l(v-html="financialFriendly.area02_Content")
</template>

<script>
import { getFinancialFriendly } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsSocialResponsibilityStaffCard",
  metaInfo() {
    return {
      title: this.financialFriendly.SEO_Title,
      meta: [
        {
          name: "description",
          content: this.financialFriendly.SEO_Description,
        },
      ],
    };
  },
  components: {
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      financialFriendly: {},
    };
  },
  created() {
    this.getFinancialFriendly();
  },
  methods: {
    getFinancialFriendly() {
      getFinancialFriendly().then((response) => {
        this.financialFriendly = response.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/social_responsibility/common";
@import "@/assets/style/about_us/social_responsibility/financial";
</style>
